/*
* tab
*/
export default class Tab {
  constructor() {
    this.$tabButton = document.querySelectorAll('[data-target="tabButton"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$tabButton, $button => {
      $button.addEventListener('change', () => {
        const tabIndex = $button.getAttribute('data-index');
        const tabName = $button.getAttribute('data-tab-name');
        const $tabContents = [].slice.call(document.querySelectorAll(`[data-tab="${tabName}"]`));
        const $active = $tabContents.find((tab) => tab.classList.contains('is-active'));

        if ($active) {
          $active.classList.remove('is-active');
        }
        if ($tabContents[tabIndex]) {
          $tabContents[tabIndex].classList.add('is-active');
        }
      });
    });
  }
}
